import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

import { SoftUIControllerProvider } from "context";
import { ColorThemeProvider } from "./context/ColorThemeContext";
import ErrorBoundary from "./layouts/error/ErrorBoundary"; // ✅

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <SoftUIControllerProvider>
      <ColorThemeProvider>
        <ErrorBoundary>
          {" "}
          {/* ✅ Bọc toàn bộ App */}
          <App />
        </ErrorBoundary>
      </ColorThemeProvider>
    </SoftUIControllerProvider>
  </BrowserRouter>
);
// window.onerror = function (message, source, lineno, colno, error) {
//   console.error("🌍 Global Error:", message, error);
//   // Optionally redirect to a fallback page
//   window.location.href = "/error";
//   return true; // ✅ Ngăn browser hiện lỗi
// };

// window.onunhandledrejection = function (event) {
//   console.error("❌ Unhandled Promise:", event.reason);
//   window.location.href = "/error";
//   return true;
// };
